module.exports = "/_next/static/images/paul-gilbert-5f8d5048d423a054aa26c34771ef04a8.png";